import React from 'react'
import { identity } from 'lodash'


import { useSearch } from '../../hooks/useSearch'

import { Select } from './Select'
import { Trad } from './Trad'

export const SearchSelect = ({
  time, min, placeholder = 'search', onSearch, value, prefilledText, ...props
}) => {
  const { handleSearch, inputValue } = useSearch({
    time, min, onSearch, getValue: identity,
  })

  const finalHandleSearch = (value, { action }) => {
    if (action === 'input-change') {
      handleSearch(value)
    }
  }

  return (
    <Select
      noOptionsMessage={() => <Trad id="noResult" />}
      inputValue={value ? '' : inputValue}
      placeholder={prefilledText || placeholder}
      onBlurResetsInput
      onInputChange={finalHandleSearch}
      value={value}
      prefilledText={prefilledText}
      {...props}
    />
  )
}
